(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dv-service-links"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    document.querySelectorAll('.dv-service-menu[open]').forEach(function (menu) {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
    var link = event.target.closest('a[data-dv-service]');
    if (!link) return;
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    } catch (_) { return; }
    var destinations = ['shop_orders', 'subscription_portal', 'wholesale_portal', 'signup_dog', 'signup_cat', 'wholesale_apply', 'breeder_apply', 'breeder_portal'];
    var placements = ['header', 'drawer', 'footer', 'subscription_page', 'wholesale_page', 'breeder_page'];
    if (!destinations.includes(link.dataset.dvService) || !placements.includes(link.dataset.placement)) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'dv_service_navigation', destination: link.dataset.dvService, placement: link.dataset.placement });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.dv-service-menu[open]').forEach(function (menu) {
      menu.removeAttribute('open');
      if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
